import { MeteringPoint } from "components/ElectricityAgreements/models";

export interface ElectricityAgreementRenewalPlan {
  id: number;
  contractNumber: string;
  customer: {
     id: number,
     isPerson: boolean,
     name: string,
     isChargingClient: boolean
  };
  meteringPoints: MeteringPoint[];
  consumptionPackage?: {
    id: number;
    nameEt: string;
    marketPricePackage: boolean;
    dynamicPackage: boolean;
    twoTariffPackage: boolean;
  };
  productionPackageId?: number;
  contractPeriodId?: number;
  basePriceCentsKwh?: number;
  dayTariffCentsKwh?: number;
  nightTariffCentsKwh?: number;
  monthlyFeeEuros?: number;
  consumptionMarginalCentsKwh?: number;
  productionMarginalCentsKwh?: number;
  offerSendDate?: string;
  offerAutoAcceptDate?: string;
  type: ElectricityAgreementRenewalPlanType;
  status: ElectricityAgreementRenewalPlanStatus;
}

export enum ElectricityAgreementRenewalPlanType {
    RENEWAL = "RENEWAL",
    PROCUREMENT = "PROCUREMENT"
}

export enum ElectricityAgreementRenewalPlanStatus {
  PLANNED = "PLANNED",
  INCOMPLETE = "INCOMPLETE",
  PENDING = "PENDING",
  CANCELED = "CANCELED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  AUTO_ACCEPTED = "AUTO_ACCEPTED"
}

export enum ElectricityAgreementRenewalPlanSortFields {
  ID = "ID"
}

export interface ElectricityAgreementRenewalPlanFilters {
  searchQuery?: string;
  type?: ElectricityAgreementRenewalPlanType;
  publicPackageId?: number;
  status?: ElectricityAgreementRenewalPlanStatus;
  offerSendDateStart?: string;
  offerSendDateEnd?: string;
}

export const ELECTRICITY_AGREEMENT_RENEWAL_PLAN_TYPE_MAP: Record<ElectricityAgreementRenewalPlanType, string> = {
    RENEWAL: 'Pikendus',
    PROCUREMENT: 'Hange'
};

export const ELECTRICITY_AGREEMENT_RENEWAL_PLAN_STATUS_MAP: Record<ElectricityAgreementRenewalPlanStatus, string> = {
    PLANNED: 'Plaanitud',
    INCOMPLETE: 'Täiendamata',
    PENDING: 'Ootel',
    CANCELED: 'Tühistatud',
    ACCEPTED: 'Aktsepteeritud',
    REJECTED: 'Tagasilükatud',
    AUTO_ACCEPTED: 'Automaatne aktsepteeritud'
};
